import { Voltage } from '../../../../../../domain/Voltage';
import { AttentionStatus } from '../../../../../AttentionStatus';
import { EvaluationResult } from '../../../../../EvaluatedResult';
import type { EvaluationResultType } from '../../../../../EvaluatedResult';
import type { ForRuleProviding } from '../../../../../RulesProvider';

export class VoltageEvaluation {
  private readonly ruleName = 'Lv_Busbar_Voltage';

  constructor(private readonly ruleProvider: ForRuleProviding) {}

  public evaluate(voltage: number): EvaluationResultType<Voltage> {
    const rule = this.ruleProvider.getRule(this.ruleName);
    const status = AttentionStatus.fromAlertScale(rule?.value, voltage);
    const value = new Voltage(voltage).toKilo();
    return EvaluationResult.from(status, value, this.ruleName);
  }
}
